<template>
  <AppDrop
    @drop="moveCampo"
    class="columnForm"
    :style="{width:column.ancho +'px'}"

  >
    <!-- <AppDrag
      class="columnForm"
      :transferData="{
        type: 'column',
        fromColumnIndex: columnIndex
      }"

    > -->
      <div style="font-weight: 700; align-items: center; margin-bottom: 0.5rem;" >
        <v-row no-gutters>
          <v-col cols="12" >
            {{ column.name}}  {{columnIndex==1 ? ' : ' + FormName : ''}}
          </v-col>
          <v-col cols="12"  v-if="columnIndex==1">
            <FormControl
            v-model="FormName"
            ></FormControl>
          </v-col>
        </v-row>  
      </div>
      <div>
        <ColumnTask
          v-for="(campos, _camposIndex) of column.campos"
          :key="_camposIndex"
          :campos="campos"
          :camposIndex="_camposIndex"
          :column="column"
          :columnIndex="columnIndex"
          :board="board" />
        <!-- para dejar el boton de crear nuevas tareas  -->
        <!-- <input
          type="text"
          class="nuevo"
          placeholder="+ Enter new task"
          @keyup.enter="createTask($event, column.tasks)"
        />  -->
        
      </div>
      
    <!-- </AppDrag> -->

  </AppDrop>
</template>

<script>
// import AppDrag from '@/components/dragdrop/AppDrag'
import ColumnTask from '@/components/dragdrop/ColumnTask.vue'
import AppDrop from '@/components/dragdrop/AppDrop'
import movingTasksAndColumnsMixin from '@/mixins/movingTasksAndColumnsMixin'
import FormControl from '@/components/dragdrop/FormControl.vue'

export default {
  name:"BoardColumn",
  components: {
    ColumnTask,
    AppDrop,
    FormControl,
    // AppDrag,
  },
  mixins: [movingTasksAndColumnsMixin],
  data() {
    return {
      FormName: 'Sin Nombre de Formulario'
    }
  },
  methods: {
    pickupColumn (e, fromColumnIndex) {
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.dropEffect = 'move'

      e.dataTransfer.setData('from-column-index', fromColumnIndex)
      e.dataTransfer.setData('type', 'column')
    },
    // createTask (e, tasks) {
    //   this.$store.commit('CREATE_TASK', {
    //     tasks,
    //     name: e.target.value
    //   })
    //   e.target.value = ''
    // }
  }
}
</script>

<style lang="css">
.columnForm {
  padding: 0.5rem;
  margin-right: 1rem;
  /* min-width: 500px; */
  text-align: left;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-radius: .25rem;
  background: #D2EDF2;
  color:#064b83;
  font-size: 1.3em;
  height: 93vh;
  overflow: auto;
}
</style>
